module.exports = __webpack_public_path__ + "img/mobile-device.f22d247f.svg";